/*
  nero-panier.js — Nerosanté, tiroir panier XBoost (07/10/2026, Alfred). Chargé par snippets/nero-panier.liquid.

  1. L'urgence de commande, en haut du tiroir, au-dessus du produit, hors de la zone qui défile (toujours visible),
     sur UNE ligne (v2, demande d'Arnaud du 07/10) : « Commandez dans 4:59 · livré sous 6 à 10 jours ».
     Si la phrase déborde (petit téléphone), sa taille baisse par demi-pixel jusqu'à tenir (10,5 px au plus petit).
     5 minutes à partir de la première ouverture du tiroir non vide, gardées pour la session (sessionStorage) :
     pas de nouveau départ au rechargement ni à chaque ouverture. À zéro : « Commandez maintenant · livré sous
     6 à 10 jours ». Si l'annonce à minuteur de XBoost (« Panier sauvegardé pendant… », éteinte
     aujourd'hui) est un jour rallumée, la nôtre s'efface : jamais deux minuteurs.

  2. La carte « nerosante+ Care », sur le modèle de Neurogena, habille l'option de XBoost
     « Garantie à Vie & Remplacement Offert » (produit protection-livraison). Son bouton transmet le clic à
     l'interrupteur de XBoost, devenu invisible : c'est XBoost qui ajoute ou retire la protection et refait le total.
     Pas d'interrupteur XBoost → pas de carte, et l'interrupteur d'origine redevient visible.

  3. (10/10, demande d'Arnaud de 22:09) La phrase « Une protection à vie — un seul paiement, sans abonnement. »
     s'affiche partout, sur une ligne (12 px, descend par demi-pixel jusqu'à 10,5 px si elle déborde, comme
     l'urgence). Trois points (10/10 23:04, sur le modèle Neurogena : garantie à vie, retours et échanges
     gratuits, retour prolongé), dont le dernier dépend du panier : « Retour prolongé à 90 jours » s'il contient
     2 ORL Système ou plus (quantité totale des lignes orl-systeme, lot Kaching compris), 60 jours sinon.
     La quantité vient de /cart.js : lue au chargement, à chaque ouverture du tiroir, après chaque requête qui
     modifie le panier (/cart/add|change|update|clear, vue par PerformanceObserver) et quand la liste des produits
     du tiroir change. Le nombre n'est réécrit que s'il change (sinon l'observateur boucle).
     Tant qu'une lecture est attendue (1,5 s au plus), la carte attend pour naître : sinon, juste après l'ajout
     d'un lot de 2, elle afficherait 60 puis 90.

  4. (11/10, politique de retour publiée le matin) Le badge du pied du tiroir, écrit par XBoost dans ses réglages
     (« 60-JOURS SATISFACTION GARANTIE », pour tous), dit le délai réel : « Satisfait ou remboursé 30 jours » avec
     1 ORL Système, 60 jours avec 2 ou plus ; si la garantie Care est cochée, 60 / 90 jours, comme sa carte.
     Seul le nœud texte de XBoost est réécrit, et seulement s'il change. Caché tant qu'une lecture de /cart.js
     est attendue, pour ne jamais montrer un délai périmé.

  5. (21/10, v7, demande d'Arnaud : « quand le client ajoute au panier… pas qu'il se dise : les cadeaux, je les ai
     ou pas ? ») Le bloc « Vos cadeaux sont inclus », juste sous le produit. On n'y ajoute AUCUNE ligne de commande :
     le guide part par l'e-mail de confirmation, le kit confort ce sont les embouts déjà dans la boîte, et la
     livraison est déjà gratuite. Les trois cadeaux s'affichent dès 2 ORL Système, ou avec la carte Kaching de l'offre
     exclusive (propriété __kaching_bundles : toute carte autre que la carte simple wGsU). Avec la carte simple seule,
     seulement « Livraison offerte », plus une ligne qui dit que le guide et le kit vont avec l'offre exclusive (sans
     lien : remplacer la ligne Kaching proprement n'est pas possible). La carte de l'offre (1 appareil, 60 jours) compte
     comme un lot pour les délais : badge 60 jours, et Care « retour prolongé à 90 jours ».
*/
(function () {
  'use strict';
  if (window.__neroPanierPret) return;
  window.__neroPanierPret = true;

  var CFG = window.neroPanier || {};
  var TX = CFG.t || {};   // textes de la langue de la page (locales) ; sans eux, le français d'origine
  function tx(cle, defaut) { return TX[cle] != null ? TX[cle] : defaut; }
  var DUREE_S = 300;
  var CLE_ECHEANCE = 'neroPanierEcheance';
  var CLE_NB = 'neroPanierNb';   // nombre d'articles vu à la dernière lecture : vide → plein = nouveau compte à rebours (Arnaud, 22/10)
  var LIVRAISON = tx('panier_livraison', ' · livré sous 6 à 10 jours');
  var TAILLE_MAX = 13, TAILLE_MIN = 10.5;
  var SOUS_MAX = 12, SOUS_MIN = 10.5;
  var CLASSE_ACTIVE = 'nero-care-actif';
  var PRODUIT = 'orl-systeme';
  var CARTE_SIMPLE = 'wGsU';                         // la carte ① « 1 x ORL Système® » à 30 jours, sans cadeaux (identifiant hérité de Kaching)
  var JOURS_UN = 60, JOURS_PLUSIEURS = 90;          // avec Care
  var JOURS_ESSAI = 30, JOURS_LOT = 60;             // sans Care (1 pièce / lot de 2)
  var BADGE_JOURS = /jours|d[ií]as|giorni/i, BADGE_MOT = /satisf|garanti|rembours|reembols|rimbors|soddisf/i;
  var MODIFIE_PANIER = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var RELECTURE_MS = 60;
  var ATTENTE_LECTURE_MS = 1500;
  var ATTENTE_MAX_MS = 8000;
  var ECHEC_MS = 2500;
  var TOUR_MS = 300;

  var COCHE = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10.4" fill="rgba(255,255,255,.2)"/><path d="M7.6 12.4 10.6 15.4 16.6 9" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var HORLOGE = '<svg class="nero-urgence__ico" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="13" r="8" stroke="currentColor" stroke-width="2"/><path d="M12 9v4l2.5 2.5M9.5 2.5h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  var ETATS = {
    libre: { bouton: tx('panier_bouton_libre', 'Ajouter la garantie à vie'), note: tx('panier_note', 'Sans abonnement. Aucun renouvellement.') },
    ajout: { bouton: tx('panier_bouton_ajout', 'Ajout…'), note: tx('panier_note', 'Sans abonnement. Aucun renouvellement.') },
    retrait: { bouton: tx('panier_bouton_retrait', 'Retrait…'), note: tx('panier_note', 'Sans abonnement. Aucun renouvellement.') },
    ajoutee: { bouton: tx('panier_bouton_ajoutee', '✓ Garantie à vie ajoutée'), note: tx('panier_note_ajoutee', 'Ajoutée à votre commande · ') },
    echec: { bouton: tx('panier_bouton_echec', 'Échec, réessayez'), note: tx('panier_note', 'Sans abonnement. Aucun renouvellement.') }
  };

  var enCours = null;   // { voulu: true|false, depuis: ms } pendant qu'XBoost ajoute ou retire
  var echecJusqua = 0;
  var echeanceMemo = 0;
  var qteProduit = null;   // ORL Système dans le panier (/cart.js) ; null tant qu'il n'a pas répondu
  var offreProduit = false; // une ligne ORL Système vient d'une autre carte Kaching que la carte simple (offre exclusive, Duo)
  var lecture = 0;          // numéro de la dernière lecture partie : seule la plus récente compte
  var relectureMinuteur = null;
  var lectureDepuis = 0;    // une lecture est attendue depuis… (0 = aucune) : la carte ne naît pas avec un nombre périmé
  var tiroirOuvert = false;
  var signatureLignes = '';

  /* ---------- la quantité d'ORL Système, lue dans /cart.js ---------- */
  function lirePanier() {
    var n = ++lecture;
    if (!lectureDepuis) lectureDepuis = Date.now();
    var finie = function () { if (n === lecture) { lectureDepuis = 0; planifier(); } };
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('/cart.js ' + r.status); return r.json(); })
      .then(function (c) {
        if (n !== lecture) return;
        var q = 0, offre = false;
        (c.items || []).forEach(function (l) {
          if (l.handle !== PRODUIT) return;
          q += l.quantity;
          // 23/10 (sans Kaching) : la carte se lit dans `_nero_offre` (« wGsU · … » = carte simple) ; les paniers d'avant
          // la bascule gardent `__kaching_bundles`.
          var n = l.properties && l.properties._nero_offre;
          if (n) { if (String(n).indexOf(CARTE_SIMPLE) === -1) offre = true; return; }
          var k = l.properties && l.properties.__kaching_bundles;
          if (k) { try { var o = JSON.parse(k); var carte = o && (o.bar || o.bid); if (carte && carte !== CARTE_SIMPLE) offre = true; } catch (e) { /* propriété illisible : carte simple */ } }
        });
        qteProduit = q;
        offreProduit = offre;
        suivreRemplissage(c.item_count || 0);
        finie();
      })
      .catch(function (e) { if (window.console) console.warn('nero-panier', e); finie(); });
  }
  function relirePanier() {
    if (!lectureDepuis) lectureDepuis = Date.now();
    clearTimeout(relectureMinuteur);
    relectureMinuteur = setTimeout(lirePanier, RELECTURE_MS);
  }
  // Le panier vient de changer et /cart.js n'a pas encore répondu (1,5 s au plus) : la carte attend pour naître,
  // sinon elle afficherait 60 puis 90 juste après l'ajout d'un lot de 2.
  function lectureAttendue() { return !!lectureDepuis && Date.now() - lectureDepuis < ATTENTE_LECTURE_MS; }
  function commeUnLot() { return qteProduit !== null && (qteProduit >= 2 || (qteProduit >= 1 && offreProduit)); }
  function joursRetour() { return commeUnLot() ? JOURS_PLUSIEURS : JOURS_UN; }

  /* ---------- l'échéance des 5 minutes ---------- */
  function echeance() {
    if (echeanceMemo) return echeanceMemo;
    var v = 0;
    try { v = parseInt(sessionStorage.getItem(CLE_ECHEANCE), 10) || 0; } catch (e) { v = 0; }
    if (!v) {
      v = Date.now() + DUREE_S * 1000;
      try { sessionStorage.setItem(CLE_ECHEANCE, String(v)); } catch (e) { /* navigation privée : l'échéance vit le temps de la page */ }
    }
    echeanceMemo = v;
    return v;
  }
  // Le panier était vide (0 article à la lecture d'avant) et un produit y revient : 5 minutes de nouveau.
  // Un rechargement, une réouverture du tiroir ou un 2ᵉ article ne relancent rien. Écrit seulement quand le nombre change.
  function suivreRemplissage(total) {
    var avant = null;
    try { var brut = sessionStorage.getItem(CLE_NB); avant = brut === null ? null : parseInt(brut, 10); } catch (e) { avant = null; }
    if (avant === 0 && total > 0) {
      echeanceMemo = Date.now() + DUREE_S * 1000;
      try { sessionStorage.setItem(CLE_ECHEANCE, String(echeanceMemo)); } catch (e) { /* navigation privée : l'échéance vit le temps de la page */ }
    }
    if (avant !== total) { try { sessionStorage.setItem(CLE_NB, String(total)); } catch (e) { /* idem */ } }
  }
  function resteS() {
    var s = Math.round((echeance() - Date.now()) / 1000);
    return s > 0 ? s : 0;
  }
  function format(s) {
    var m = Math.floor(s / 60), r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  /* ---------- lecture du tiroir XBoost ---------- */
  function corps() { return document.querySelector('.xb_slide_cart_body_wrapper'); }
  function visible(el) { return !!(el && el.getClientRects().length); }
  function aDesProduits(racine) { return !!racine.querySelector('.xb_slide_cart_product_line'); }
  function optionXB(racine) {
    var blocs = racine.querySelectorAll('.xb-slidecart-addons');
    for (var i = 0; i < blocs.length; i++) {
      if (/garantie/i.test(blocs[i].textContent)) return blocs[i];
    }
    return blocs[0] || null;
  }
  function caseXB(bloc) {
    if (!bloc) return null;
    return bloc.querySelector('label input[type="checkbox"].xb-sr-only') || bloc.querySelector('input[type="checkbox"]');
  }
  function prixDe(bloc) {
    var m = ((bloc && bloc.textContent) || '').match(/\d+(?:[.,]\d{2})?\s?€/);
    if (m) return m[0].replace(/\s?€/, ' €');
    return CFG.prix || '';
  }
  function annonceXBPresente(racine, haut) {
    if (/Panier sauvegard/i.test(racine.textContent)) return true;
    if (!haut) return false;
    for (var n = haut.firstElementChild; n; n = n.nextElementSibling) {
      if (!n.classList.contains('nero-urgence') && /\d{1,2}:\d{2}/.test(n.textContent)) return true;
    }
    return false;
  }

  /* ---------- 1. l'urgence ---------- */
  // Une seule ligne : on part de 13 px et on descend par demi-pixel tant que la phrase déborde.
  // Recalculé seulement quand la largeur ou la phrase changent (les chiffres du minuteur ont tous la même largeur).
  function reduireJusquaTenir(boite, texte, max, min) {
    var taille = max;
    boite.style.fontSize = '';
    while (texte.scrollWidth > texte.clientWidth + 1 && taille > min) {
      taille -= 0.5;
      boite.style.fontSize = taille + 'px';
    }
  }
  function uneLigne(u, t) {
    var cle = u.clientWidth + '|' + (t.querySelector('.nero-urgence__t') ? 'minuteur' : 'fin');
    if (!u.clientWidth || u.__neroCle === cle) return;
    u.__neroCle = cle;
    reduireJusquaTenir(u, t, TAILLE_MAX, TAILLE_MIN);
  }
  function majUrgence(u) {
    var t = u.querySelector('.nero-urgence__txt');
    var s = resteS();
    if (s <= 0) {
      var fin = tx('panier_commandez_maintenant', 'Commandez maintenant') + LIVRAISON;
      if (t.textContent !== fin) t.textContent = fin;
      uneLigne(u, t);
      return;
    }
    var h = t.querySelector('.nero-urgence__t');
    if (!h) {
      t.innerHTML = tx('panier_commandez_dans', 'Commandez dans') + ' <b class="nero-urgence__t"></b>' + LIVRAISON;
      h = t.querySelector('.nero-urgence__t');
    }
    var v = format(s);
    if (h.textContent !== v) h.textContent = v;
    uneLigne(u, t);
  }
  function poserUrgence(bw, racine) {
    var haut = bw.querySelector('.xb_slide_cart_body_wrapper_top');
    var u = racine.querySelector('.nero-urgence');
    if (!aDesProduits(racine) || annonceXBPresente(racine, haut)) {
      if (u) u.parentNode.removeChild(u);
      return;
    }
    if (!u) {
      u = document.createElement('div');
      u.className = 'nero-urgence';
      u.innerHTML = HORLOGE + '<span class="nero-urgence__txt"></span>';
    }
    if (u.nextElementSibling !== bw) bw.parentNode.insertBefore(u, bw);   // entre l'en-tête et la liste, sans défiler
    majUrgence(u);
  }

  /* ---------- 2. la carte « Care » ---------- */
  function construireCarte(prix) {
    var c = document.createElement('div');
    c.className = 'nero-care';
    c.innerHTML =
      '<div class="nero-care__in">' +
        '<div class="nero-care__haut">' +
          '<span class="nero-care__mot">Care</span>' +
          '<span class="nero-care__pastille">' + tx('panier_pastille', 'PAIEMENT UNIQUE') + '</span>' +
        '</div>' +
        '<p class="nero-care__sous">' + tx('panier_sous', 'Une protection à vie — un seul paiement, sans abonnement.') + '</p>' +
        '<ul class="nero-care__liste">' +
          '<li>' + COCHE + '<span><b>' + tx('panier_l1_gras', 'Garantie à vie') + '</b>' + tx('panier_l1_suite', ' au lieu de 2 ans') + '</span></li>' +
          '<li>' + COCHE + '<span><b>' + tx('panier_l2', 'Retours et échanges gratuits') + '</b></span></li>' +
          '<li>' + COCHE + '<span><b>' + tx('panier_l3_avant', 'Retour prolongé à ') + '<span class="nero-care__jours">' + joursRetour() + '</span>' + tx('panier_l3_apres', ' jours') + '</b></span></li>' +
        '</ul>' +
        '<div class="nero-care__pied">' +
          '<div class="nero-care__prix"><span class="nero-care__montant"></span><span class="nero-care__per">' + tx('panier_per', 'paiement unique') + '</span></div>' +
          '<button type="button" class="nero-care__btn" data-nero-care="ajouter"></button>' +
        '</div>' +
        '<p class="nero-care__note"></p>' +
      '</div>';
    var haut = c.querySelector('.nero-care__haut');
    var marque;
    if (CFG.logo) {
      marque = document.createElement('img');
      marque.className = 'nero-care__logo';
      marque.src = CFG.logo;
      marque.alt = 'nerosante+';
      marque.width = 110;
      marque.height = 20;
    } else {
      marque = document.createElement('span');
      marque.className = 'nero-care__marque';
      marque.textContent = 'nerosante+';
    }
    haut.insertBefore(marque, haut.firstChild);
    c.querySelector('.nero-care__montant').textContent = prix;
    return c;
  }

  function etatVoulu(coche) {
    if (enCours) {
      if (coche === enCours.voulu) enCours = null;
      else if (Date.now() - enCours.depuis > ATTENTE_MAX_MS) { enCours = null; echecJusqua = Date.now() + ECHEC_MS; }
    }
    if (enCours) return enCours.voulu ? 'ajout' : 'retrait';
    if (Date.now() < echecJusqua) return 'echec';
    return coche ? 'ajoutee' : 'libre';
  }

  // La phrase du haut sur une ligne : 12 px, puis par demi-pixel jusqu'à 10,5 ; si elle déborde encore, deux lignes
  // plutôt que coupée. Recalculé seulement quand la largeur de la carte (ou l'état des polices) change.
  function sousUneLigne(s) {
    var cle = s.clientWidth + '|' + (document.fonts ? document.fonts.status : '');
    if (!s.clientWidth || s.__neroCle === cle) return;
    s.__neroCle = cle;
    s.classList.remove('nero-care__sous--2l');
    reduireJusquaTenir(s, s, SOUS_MAX, SOUS_MIN);
    if (s.scrollWidth > s.clientWidth + 1) s.classList.add('nero-care__sous--2l');
  }

  function majCarte(carte, coche, prix) {
    var montant = carte.querySelector('.nero-care__montant');
    if (prix && montant.textContent !== prix) montant.textContent = prix;
    var jours = carte.querySelector('.nero-care__jours');
    var x = String(joursRetour());
    if (jours && jours.textContent !== x) jours.textContent = x;   // seulement s'il change : sinon l'observateur boucle
    sousUneLigne(carte.querySelector('.nero-care__sous'));
    var etat = etatVoulu(coche);
    if (carte.getAttribute('data-etat') === etat) return;
    carte.setAttribute('data-etat', etat);
    var b = carte.querySelector('.nero-care__btn');
    var note = carte.querySelector('.nero-care__note');
    b.textContent = ETATS[etat].bouton;
    b.disabled = etat !== 'libre' && etat !== 'echec';
    note.textContent = ETATS[etat].note;
    if (etat === 'ajoutee') {
      var r = document.createElement('button');
      r.type = 'button';
      r.className = 'nero-care__retirer';
      r.setAttribute('data-nero-care', 'retirer');
      r.textContent = tx('panier_retirer', 'Retirer');
      note.appendChild(r);
    }
  }

  function poserCarte(bw, racine) {
    var bloc = optionXB(racine);
    var cc = caseXB(bloc);
    var carte = racine.querySelector('.nero-care');
    if (!cc || !aDesProduits(racine)) {
      if (carte) carte.parentNode.removeChild(carte);
      if (!cc) document.documentElement.classList.remove(CLASSE_ACTIVE);
      return;
    }
    if (!carte) {
      if (lectureAttendue()) return;   // l'interrupteur XBoost reste caché ; la carte naît au tour suivant
      carte = construireCarte(prixDe(bloc));
      bw.appendChild(carte);
    } else if (carte.parentNode !== bw || bw.lastElementChild !== carte) {
      bw.appendChild(carte);   // XBoost a rendu un bloc après la carte : elle redescend juste au-dessus du pied
    }
    document.documentElement.classList.add(CLASSE_ACTIVE);
    majCarte(carte, cc.checked, prixDe(bloc));
  }

  function basculer(voulu) {
    var bw = corps();
    if (!bw) return;
    var racine = bw.closest('.xb_slidecart') || bw.parentNode;
    var cc = caseXB(optionXB(racine));
    var carte = racine.querySelector('.nero-care');
    if (!cc || !carte) return;
    if (cc.checked !== voulu) {
      enCours = { voulu: voulu, depuis: Date.now() };
      cc.click();   // XBoost : /cart/add.js (ajout) ou /cart/change.js (retrait), puis nouveau total
    }
    majCarte(carte, cc.checked, '');
  }

  /* ---------- 4. le badge de satisfaction du pied du tiroir ---------- */
  function texteBadge(racine) {
    var pied = racine.querySelector('.xb_slide_cart_footer');
    if (!pied) return null;
    var w = document.createTreeWalker(pied, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (BADGE_JOURS.test(n.nodeValue) && BADGE_MOT.test(n.nodeValue)) return n;
    }
    return null;
  }
  function poserBadge(racine) {
    var n = texteBadge(racine);
    if (!n) return;
    var el = n.parentElement;
    var attendre = lectureAttendue() ? 'hidden' : '';
    if (el.style.visibility !== attendre) el.style.visibility = attendre;
    if (attendre) return;
    var cc = caseXB(optionXB(racine));
    var plusieurs = commeUnLot();   // panier illisible : le délai le plus court, jamais un délai promis à tort
    var jours = cc && cc.checked ? (plusieurs ? JOURS_PLUSIEURS : JOURS_UN) : (plusieurs ? JOURS_LOT : JOURS_ESSAI);
    var t = tx('panier_badge', 'Satisfait ou remboursé {{ n }} jours').replace('{{ n }}', jours);
    if (n.nodeValue !== t) n.nodeValue = t;   // seulement s'il change : sinon l'observateur boucle
  }

  /* ---------- 5. les cadeaux inclus ---------- */
  var CADEAU_SVG = '<svg class="nero-cp__ico" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.5 8.5h17v4h-17zM5 12.5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7M12 8.5v12" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M12 8.5c-1.2-2.6-4.6-4.2-5.6-2.3-.8 1.6 1.4 2.3 5.6 2.3Zm0 0c1.2-2.6 4.6-4.2 5.6-2.3.8 1.6-1.4 2.3-5.6 2.3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var CADEAUX = [
    { cle: 'livraison', nom: tx('bonus_nom_livraison', 'Livraison offerte'), mot: tx('panier_offerte', 'Offerte'), valeur: '4,99 €', alt: tx('bonus_alt_colis', 'Un colis') },
    { cle: 'guide', nom: tx('bonus_nom_guide', 'Guide Oreilles nettes'), mot: tx('panier_offert', 'Offert'), valeur: '9,90 €', alt: tx('bonus_alt_guide', 'Le guide « Oreilles nettes »') },
    { cle: 'kit', nom: tx('bonus_nom_kit', 'Kit confort'), mot: tx('panier_offert', 'Offert'), valeur: '20 €', alt: tx('bonus_alt_kit', 'Trois embouts souples en silicone') }
  ];
  function htmlCadeaux(etat) {
    var img = CFG.cadeaux || {};
    if (/-compact$/.test(etat)) {   // 2 lignes ou plus : une seule ligne, pour que la Care reste entière sans défiler
      var tout = etat.indexOf('tout') === 0;
      return '<p class="nero-cp__titre nero-cp__titre--seul">' + CADEAU_SVG + '<span class="nero-cp__resume"><b>' + (tout ? tx('panier_cadeaux3', 'Vos 3 cadeaux sont inclus') : tx('panier_cadeau1', 'Votre cadeau est inclus')) + '</b></span><span class="nero-cp__prix"><s>' + (tout ? '34,89 €' : '4,99 €') + '</s><b>' + (tout ? tx('panier_offerts', 'Offerts') : tx('panier_offerte', 'Offerte')) + '</b></span></p>';
    }
    var liste = etat === 'tout' ? CADEAUX : CADEAUX.slice(0, 1);
    var h = '<p class="nero-cp__titre">' + CADEAU_SVG + '<span>' + (etat === 'tout' ? tx('panier_cadeaux', 'Vos cadeaux sont inclus') : tx('panier_cadeau1', 'Votre cadeau est inclus')) + '</span></p><ul class="nero-cp__liste" role="list">';
    liste.forEach(function (c) {
      h += '<li class="nero-cp__ligne"><span class="nero-cp__vignette">' + (img[c.cle] ? '<img src="' + img[c.cle] + '" width="64" height="64" alt="' + c.alt + '" loading="lazy" decoding="async">' : '') + '</span>' +
           '<span class="nero-cp__nom">' + c.nom + '</span>' +
           '<span class="nero-cp__prix"><s>' + c.valeur + '</s><b>' + c.mot + '</b></span></li>';
    });
    h += '</ul>';
    if (etat !== 'tout') h += '<p class="nero-cp__note">' + tx('panier_note_guide_kit', 'Le guide et le kit confort sont offerts avec l’offre exclusive d’octobre.') + '</p>';
    return h;
  }
  function poserCadeaux(racine) {
    var bloc = racine.querySelector('.nero-cadeaux-panier');
    var produits = racine.querySelector('.xb_slide_cart_products');
    if (!produits || !aDesProduits(racine) || qteProduit === null || qteProduit < 1) {
      if (bloc && !lectureAttendue()) bloc.parentNode.removeChild(bloc);
      return;
    }
    if (lectureAttendue()) return;   // jamais l'état d'avant l'ajout (1 cadeau puis 3)
    var etat = (commeUnLot() ? 'tout' : 'livraison') + (racine.querySelectorAll('.xb_slide_cart_product_line').length >= 2 ? '-compact' : '');
    if (!bloc) { bloc = document.createElement('div'); bloc.className = 'nero-cadeaux-panier'; }
    if (bloc.getAttribute('data-etat') !== etat) { bloc.setAttribute('data-etat', etat); bloc.innerHTML = htmlCadeaux(etat); }
    if (produits.nextElementSibling !== bloc) produits.parentNode.insertBefore(bloc, produits.nextSibling);   // juste sous le produit
  }

  /* ---------- la boucle ---------- */
  // Ce que le tiroir montre des produits (texte + quantités) : s'il change, le panier a changé → relire /cart.js
  function signature(racine) {
    var lignes = racine.querySelectorAll('.xb_slide_cart_product_line');
    var s = String(lignes.length);
    for (var i = 0; i < lignes.length; i++) {
      s += '#' + lignes[i].textContent.replace(/\s+/g, ' ');
      var champs = lignes[i].querySelectorAll('input');
      for (var j = 0; j < champs.length; j++) s += '|' + champs[j].value;
    }
    return s;
  }

  function appliquer() {
    try {
      var bw = corps();
      var ouvert = !!bw && visible(bw);
      if (ouvert && !tiroirOuvert) relirePanier();   // à chaque ouverture, pas à chaque tour
      tiroirOuvert = ouvert;
      if (!ouvert) return;   // tiroir fermé : rien ne démarre, pas même les 5 minutes
      var racine = bw.closest('.xb_slidecart') || bw.parentNode;
      var sig = signature(racine);
      if (sig !== signatureLignes) { signatureLignes = sig; relirePanier(); }
      poserUrgence(bw, racine);
      poserCarte(bw, racine);
      poserCadeaux(racine);
      poserBadge(racine);
    } catch (e) {
      document.documentElement.classList.remove(CLASSE_ACTIVE);   // en cas de pépin : l'interrupteur d'origine revient
      if (window.console) console.warn('nero-panier', e);
    }
  }

  var prevu = false;
  function planifier() {
    if (prevu) return;
    prevu = true;
    var fait = false;
    var lancer = function () { if (fait) return; fait = true; prevu = false; appliquer(); };
    if (window.requestAnimationFrame) requestAnimationFrame(lancer);
    setTimeout(lancer, 120);
  }

  // En phase de capture : le tiroir XBoost arrête la propagation des clics, un écouteur ordinaire ne les verrait pas.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-nero-care]') : null;
    if (!b) { planifier(); return; }
    e.preventDefault();
    if (b.disabled) return;
    basculer(b.getAttribute('data-nero-care') === 'ajouter');
  }, true);

  // Posée d'avance pour éviter que l'ancien interrupteur ne clignote à l'ouverture ; retirée si la carte ne peut pas se poser.
  document.documentElement.classList.add(CLASSE_ACTIVE);
  new MutationObserver(planifier).observe(document.documentElement, { childList: true, subtree: true });
  // Toute requête qui modifie le panier (XBoost, Kaching, le thème) : relire /cart.js une fois qu'elle a abouti.
  // Notre propre lecture (/cart.js) ne correspond pas au motif : pas de boucle.
  try {
    new PerformanceObserver(function (liste) {
      var e = liste.getEntries();
      for (var i = 0; i < e.length; i++) {
        if (MODIFIE_PANIER.test(e[i].name)) { relirePanier(); return; }
      }
    }).observe({ type: 'resource' });
  } catch (e) { /* navigateur sans PerformanceObserver : l'ouverture du tiroir et la liste des produits suffisent */ }
  setInterval(appliquer, TOUR_MS);
  lirePanier();
  planifier();
})();
